import useSWR from "swr";

export const useFetchSoCouponUsedCouponUsersCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: soCouponUsedCouponUsersCount, error, isLoading: isLoadingSoCouponUsedCouponUsersCount } = useSWR<number>(`socoupon/used-coupon-users/count/?restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`)
  return { soCouponUsedCouponUsersCount, isLoadingSoCouponUsedCouponUsersCount, error };
};